import type { ProspectDashboardBucket } from "../../api/client.ts";

/** What found a company, as a chart colour: signals, agents, people. */
export const HIT_KIND_COLORS = {
  signal: "var(--mui-palette-warning-main)",
  agent: "var(--mui-palette-primary-main)",
  manual: "var(--mui-palette-text-disabled)",
};
const DAY = 86_400_000;

function bucketStart(t: number, bucket: "day" | "week"): number {
  const day = Math.floor(t / DAY) * DAY;
  if (bucket === "day") return day;
  return day - ((new Date(day).getUTCDay() + 6) % 7) * DAY;
}

export interface HitTimelinePoint {
  t: number;
  signal: number;
  agent: number;
  manual: number;
}

/** Every bucket from the period's start (or the first hit) to now, zeros where nothing hit. */
export function hitTimelinePoints(
  timeline: ProspectDashboardBucket[],
  bucket: "day" | "week",
  since: string | undefined,
): HitTimelinePoint[] {
  const byStart = new Map(timeline.map((b) => [bucketStart(Date.parse(b.start), bucket), b]));
  const first = since
    ? bucketStart(Date.parse(since), bucket)
    : timeline.length
      ? bucketStart(Date.parse(timeline[0].start), bucket)
      : null;
  if (first === null) return [];
  const step = bucket === "day" ? DAY : 7 * DAY;
  const points = [];
  for (let t = first; t <= bucketStart(Date.now(), bucket); t += step) {
    const b = byStart.get(t);
    points.push({ t, signal: b?.signal ?? 0, agent: b?.agent ?? 0, manual: b?.manual ?? 0 });
  }
  return points;
}
